import React, { useContext } from 'react';
import FormSteps from '../FormSteps';
import { CurrentUserContext } from '../../../../../contexts/currentUserContext';

/**
 * CollaborationStep Component
 *
 * Step for selecting collaboration preferences
 *
 * @param {Function} goToNextStep - Function to navigate to the next step
 * @param {Function} skipStep - Function to skip to the next step
 * @param {Component} UserCollaborateWith - The collaboration component
 */
const CollaborationStep = ({
  goToNextStep,
  skipStep,
  UserCollaborateWith
}) => {
  const user = useContext(CurrentUserContext);
  const handleNext = () => {
    goToNextStep();
  };

  return (
    <FormSteps
      header="Who would you like to typically collaborate with?"
      description="We’ll help connect you with the right people."
      nextButton={handleNext}
      skipButton={skipStep}
    >
      <UserCollaborateWith
        desiredCollaborationProfession={user.desiredCollaborationProfession ?? null}
        hideTitle={true}
      />
    </FormSteps>
  );
};

export default CollaborationStep;
